import MemberRequest from "../../../../Controllers/MemberRequest";


function getResult(data,req) {
  let res=false;
  if (data.hasOwnProperty( "gallery")) {
    let resTable=data["gallery"];
    if (resTable.hasOwnProperty("result")) {
      if (resTable["result"] === "yes") {
        res= resTable.data;
      }
    }
  }
  return res;
}


const sendDataTableApi = async function () {
  let res=false;
  let objTable={start:0, length:9, order_column:1,order_dir:2,current_page:1 };
  let req=new MemberRequest();
  req.query=`{gallery(start:"${objTable.start}",length:"${objTable.length}",order_column:"${objTable.order_column}",order_dir:"${objTable.order_dir}",filters:""){result, recordsTotal, recordsFiltered,data{id,title,fileType} } }`;
  res = await req.send(getResult);
  return res;
};

export default async function GetGalleryPicDataTableApi() {
  return await sendDataTableApi();
}
